var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25718 12.9712C3.07139 12.6549 2.93012 12.3904 2.83424 12.2025C2.93012 12.0146 3.07139 11.7501 3.25718 11.4338C3.64556 10.7726 4.22357 9.89369 4.98233 9.01825C6.51433 7.25065 8.68824 5.60156 11.4512 5.60156C14.2142 5.60156 16.3881 7.25065 17.9201 9.01825C18.6788 9.89369 19.2569 10.7726 19.6452 11.4338C19.831 11.7501 19.9723 12.0146 20.0682 12.2025C19.9723 12.3904 19.831 12.6549 19.6452 12.9712C19.2569 13.6324 18.6788 14.5113 17.9201 15.3868C16.3881 17.1543 14.2142 18.8034 11.4512 18.8034C8.68824 18.8034 6.51433 17.1543 4.98233 15.3868C4.22357 14.5113 3.64556 13.6324 3.25718 12.9712Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.602 10.6893C14.0183 9.71213 12.9272 9.05469 11.6775 9.05469C9.81284 9.05469 8.30124 10.5184 8.30124 12.3239C8.30124 13.6959 9.17407 14.8705 10.4114 15.3555",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91707 21.1156L22 2.80078",
    stroke: "white",
    strokeWidth: 2.16028
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.0025L19 4.30206",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEventIcon);
export default __webpack_public_path__ + "static/media/hide-event-icon.0436bcd3abd749c7ccd2c1bbcb0ba5d6.svg";
export { ForwardRef as ReactComponent };